import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const esimPushModule = {
  namespaced: true,
  state: {
    accessToken: null,
    status: null,
    qrInfo: null
  },
  actions: {
    loadEsimPushInfos ({ commit, state, dispatch, rootGetters }, { token, birthdate }) {
      commit('clearMessages', {}, { root: true })
      commit('resetState')
      return dispatch('loadAccessToken', { token: token, birthdate: birthdate }).then(() => {
        const errors = rootGetters.peekMessages
        if (!errors || errors.length === 0) {
          return Promise.all([dispatch('loadEsimPushStatus'), dispatch('loadQrInfos')])
        }
      })
    },
    loadAccessToken ({ commit, state }, { token, birthdate }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query eSimPush($eSimAccessInput: ESimAccessInput!){
          eSimAccess(eSimAccessInput: $eSimAccessInput) {
            accessToken
          }
        }`,
        fetchPolicy: 'no-cache',
        variables: {
          eSimAccessInput: {
            brand: 'simon',
            eSimToken: {
              token: token,
              birthdate: birthdate
            }
          }
        }
      }).then((response) => {
        commit('SET_ACCESS_TOKEN', response.data.eSimAccess.accessToken)
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    loadEsimPushStatus ({ commit, state }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query eSimPush($eSimPushStatusInput: ESimPushInput!){
          eSimPushStatus(eSimPushStatusInput: $eSimPushStatusInput) {
            serialNumber
            eid
            puk
            simStatus
            eSimStatus
            possibleActions
            success
          }
        }`,
        fetchPolicy: 'no-cache',
        variables: {
          eSimPushStatusInput: {
            brand: 'simon',
            accessToken: state.accessToken
          }
        }
      }).then((response) => {
        commit('SET_STATUS', response.data.eSimPushStatus)
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    loadQrInfos ({ commit, state }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query eSimPush($eSimQRInput: ESimQRInput!){
          eSimQR(eSimQRInput: $eSimQRInput) {
            smdpPlus
            code {
              activationCode
              confirmationCode
              ... on ESimQR {
                qrCode
              }
            }
            success
          }
        }`,
        fetchPolicy: 'no-cache',
        variables: {
          eSimQRInput: {
            brand: 'simon',
            accessToken: state.accessToken
          }
        }
      }).then((response) => {
        commit('SET_QR_INFO', response.data.eSimQR)
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    pushESim ({ commit, state }, { eid }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation eSimPush ($eSimPushAssignInput: ESimPushAssignInput!) {
          eSimPushAssign (eSimPushAssignInput: $eSimPushAssignInput) {
            success
          }
        }`,
        variables: {
          eSimPushAssignInput: {
            accessToken: state.accessToken,
            eid: eid,
            brand: 'simon'
          }
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    deassignESim ({ commit, state }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation eSimPush ($eSimPushDeassignInput: ESimPushInput!) {
          eSimPushDeassign (eSimPushStatusInput: $eSimPushDeassignInput) {
            success
          }
        }`,
        variables: {
          eSimPushDeassignInput: {
            accessToken: state.accessToken,
            brand: 'simon'
          }
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    SET_ACCESS_TOKEN (state, accessToken) {
      state.accessToken = accessToken
    },
    SET_STATUS (state, status) {
      state.status = status
    },
    SET_QR_INFO (state, qrInfo) {
      state.qrInfo = qrInfo
    },
    resetState (state) {
      state.accessToken = null
      state.status = null
    }
  },
  getters: {
    getAccessToken: state => {
      return state.accessToken
    },
    getStatus: state => {
      return state.status
    },
    getQRInfo: state => {
      return state.qrInfo
    }
  }
}

export {
  esimPushModule
}
